module.exports = __webpack_public_path__ + "static/img/13.c00411d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/eng/13.png
// module id = PbYF
// module chunks = 0